import React, { useEffect, useState } from "react";
import api from "../../../apiClient";
import { clean, dateTime, plainWords } from "../customerFormat";
import { TabState } from "./tabShared";

// Campaigns this customer received (directly, or as a lead matched to them), from
// one customer-scoped query. Read-only: running a campaign is a many-recipient send
// and belongs on the Campaigns page, not on one customer's profile.
export default function CustomerCampaignsTab({ record }) {
  const customerPk = record?.object !== "lead" ? record?.raw?.id : null;
  const [state, setState] = useState("loading");
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (!customerPk) {
      setState("none");
      return undefined;
    }
    let alive = true;
    (async () => {
      setState("loading");
      try {
        const { data } = await api.get(`/customers/${customerPk}/campaigns/`);
        if (!alive) return;
        setRows(Array.isArray(data) ? data : []);
        setState("ok");
      } catch {
        if (alive) setState("error");
      }
    })();
    return () => {
      alive = false;
    };
  }, [customerPk]);

  if (state === "none") return <TabState>Campaign history is kept on customer records.</TabState>;
  if (state === "loading") return <TabState>Loading campaigns…</TabState>;
  if (state === "error") return <TabState>Couldn't load campaigns. Try again in a moment.</TabState>;
  if (!rows.length) return <TabState>This customer hasn't been included in any Abon campaign.</TabState>;

  return (
    <section className="cov-card">
      <div className="cov-card__head">
        <span>Campaigns</span>
        <span className="cov-card__count">{rows.length}</span>
      </div>
      <div className="cov-card__body">
        {rows.map((r, i) => {
          const last = r.replied_at || r.clicked_at || r.opened_at || r.sent_at || r.created_at;
          const status = r.dry_run ? "Test run only" : plainWords(r.status);
          return (
            <div key={`${r.campaign_id}-${i}`} className="cov-row">
              <div className="cov-row__main">
                <span className="cov-row__title">{clean(r.campaign_name) || "Campaign"}</span>
                <span className="cov-row__meta">
                  {[r.channel ? plainWords(r.channel) : "", dateTime(last)].filter(Boolean).join(" · ")}
                </span>
              </div>
              <span
                className={`cov-pill ${
                  ["reply", "replied", "click", "open"].includes(r.status) ? "cov-pill--ok" : "cov-pill--muted"
                }`}
              >
                {status}
              </span>
            </div>
          );
        })}
      </div>
    </section>
  );
}
